/**
 * PLP — filtros y orden (Gudslip).
 * - Toggle del panel "Filtrar y Ordenar" (clase is-open en la sección).
 * - Auto-submit del formulario GET al cambiar checkbox/radio.
 * - Slider doble de precio: mantiene min <= max, pinta la etiqueta "X - Y€"
 *   y hace submit con debounce al soltar.
 * Va por atributos data-*: data-plp, data-plp-toggle, data-plp-form,
 * data-plp-price(-min|-max|-label).
 */
(function () {
  'use strict';

  function money(n) {
    return n.toLocaleString(document.documentElement.lang || 'es', { maximumFractionDigits: 0 }) + '€';
  }

  function init(root) {
    if (root.dataset.plpReady) return;
    root.dataset.plpReady = '1';

    // En MÓVIL el panel de filtros arranca CERRADO (en escritorio manda el ajuste
    // del editor). El usuario lo abre con "Filtrar y Ordenar".
    if (window.matchMedia('(max-width: 749px)').matches) {
      root.classList.remove('is-open');
      var t0 = root.querySelector('[data-plp-toggle]');
      if (t0) t0.setAttribute('aria-expanded', 'false');
    }

    var toggle = root.querySelector('[data-plp-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var open = root.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    var form = root.querySelector('[data-plp-form]');
    if (!form) return;

    // Checkboxes y radios: aplicar al cambiar
    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('input[type="checkbox"], input[type="radio"]')) {
        submit();
      }
    });

    // ── Slider doble de precio (portado de shopify-cafeshi-theme) ──────────
    // Los thumbs se mueven en un eje LINEAL de posición (0..SCALE) que se mapea
    // a precio de forma exponencial: así la mitad izquierda del riel cubre los
    // precios bajos y es fácil filtrar "< 30 EUR" aunque el techo sea alto.
    // Los inputs ocultos son los que envían; se vacían al quedar en los topes
    // para no ensuciar la URL.
    // QA 2026-08-14 (C3) "hay que subir mucho para que avance el importe":
    // la curva EXPONENCIAL pura ((max+1)^(pos/SCALE)-1) es demasiado agresiva para
    // este catálogo. Con el techo real (202 EUR) la mitad del riel solo llegaba a
    // 13 EUR y había que arrastrar el 77% para alcanzar la MEDIANA (57 EUR): el
    // usuario mueve y el importe no se mueve. Se sustituye por una potencia suave
    // calibrada contra la distribución real del catálogo (p25 24 EUR, mediana 57,
    // p75 115), de forma que los cuartos del riel coinciden con los cuartiles de
    // precio: 25% -> 22 EUR, 50% -> 67, 75% -> 129. Sigue dando más recorrido a
    // los precios bajos que una escala lineal, pero sin aplastar el resto.
    var SCALE = 1000;
    var CURVE = 1.6;
    // El riel va del producto MAS BARATO (minP) al mas caro (maxP): antes
    // arrancaba en 0 y se desperdiciaba el tramo donde no hay nada que filtrar.
    function priceFromPos(pos, maxP, minP) {
      minP = minP || 0;
      if (maxP <= minP) return minP;
      var t = Math.min(1, Math.max(0, pos / SCALE));
      return Math.round(minP + (maxP - minP) * Math.pow(t, CURVE));
    }
    function posFromPrice(price, maxP, minP) {
      minP = minP || 0;
      if (maxP <= minP || price <= minP) return 0;
      var t = Math.min(1, (price - minP) / (maxP - minP));
      return Math.round(SCALE * Math.pow(t, 1 / CURVE));
    }

    var price = form.querySelector('[data-plp-price]');
    var priceTimer;
    if (price) {
      var thumbMin = price.querySelector('[data-price-range="min"]');
      var thumbMax = price.querySelector('[data-price-range="max"]');
      var fill = price.querySelector('[data-price-fill]');
      var numMin = price.querySelector('[data-price-num="min"]');
      var numMax = price.querySelector('[data-price-num="max"]');
      var hidMin = price.querySelector('[data-price-input="min"]');
      var hidMax = price.querySelector('[data-price-input="max"]');
      var maxP = parseFloat(price.dataset.max) || 0;
      var minP = parseFloat(price.dataset.min) || 0;

      function paintPrice() {
        var lo = parseFloat(thumbMin.value) || 0;
        var hi = parseFloat(thumbMax.value);
        if (isNaN(hi)) hi = SCALE;
        if (lo > hi) { lo = hi; thumbMin.value = lo; }

        if (fill) {
          fill.style.left = (lo / SCALE) * 100 + '%';
          fill.style.right = 100 - (hi / SCALE) * 100 + '%';
        }

        var loP = priceFromPos(lo, maxP, minP);
        var hiP = priceFromPos(hi, maxP, minP);
        // No pisar el campo que el usuario está escribiendo
        if (numMin && numMin !== document.activeElement) numMin.value = loP;
        if (numMax && numMax !== document.activeElement) numMax.value = hiP;
        if (hidMin) hidMin.value = loP > minP ? String(loP) : '';
        if (hidMax) hidMax.value = hiP < maxP ? String(hiP) : '';
      }

      // Estado inicial: lo que venga del filtro de Shopify o, si no, de la URL.
      function initPrice() {
        var qs = new URLSearchParams(window.location.search);
        var urlMin = parseFloat(qs.get(hidMin && hidMin.name));
        var urlMax = parseFloat(qs.get(hidMax && hidMax.name));
        var iMin = !isNaN(urlMin) ? urlMin : parseFloat(price.dataset.initMin);
        var iMax = !isNaN(urlMax) ? urlMax : parseFloat(price.dataset.initMax);
        if (isNaN(iMin)) iMin = minP;
        if (isNaN(iMax)) iMax = maxP;
        thumbMin.value = posFromPrice(iMin, maxP, minP);
        thumbMax.value = posFromPrice(iMax, maxP, minP);
        paintPrice();
      }

      function delayedSubmit() {
        clearTimeout(priceTimer);
        priceTimer = setTimeout(submit, 600);
      }

      [thumbMin, thumbMax].forEach(function (input) {
        input.addEventListener('input', paintPrice);
        input.addEventListener('change', delayedSubmit);
      });

      // Campos editables: al teclear se previsualiza; al salir/Enter se aplica.
      function applyNums(commit) {
        var lo = parseFloat(numMin && numMin.value); if (isNaN(lo)) lo = 0;
        var hi = parseFloat(numMax && numMax.value); if (isNaN(hi)) hi = maxP;
        lo = Math.max(minP, Math.min(lo, maxP));
        hi = Math.max(minP, Math.min(hi, maxP));
        if (commit && lo > hi) { var t = lo; lo = hi; hi = t; }
        thumbMin.value = posFromPrice(lo, maxP, minP);
        thumbMax.value = posFromPrice(hi, maxP, minP);
        paintPrice();
        if (!commit) return;
        // Enviar el precio exacto tecleado (el ida y vuelta log puede desviar 1)
        if (hidMin) hidMin.value = lo > minP ? String(lo) : '';
        if (hidMax) hidMax.value = hi < maxP ? String(hi) : '';
        if (numMin) numMin.value = lo;
        if (numMax) numMax.value = hi;
      }

      [numMin, numMax].forEach(function (input) {
        if (!input) return;
        input.addEventListener('input', function () { applyNums(false); });
        input.addEventListener('change', function () { applyNums(true); delayedSubmit(); });
        input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); applyNums(true); submit(); }
        });
      });

      initPrice();
    }

    function submit() {
      var priceBox = form.querySelector('[data-plp-price]');
      if (priceBox) {
        // Los <range> y los campos en € NO deben viajar en la URL: solo envían
        // los ocultos, y estos se descartan si están vacíos (thumb en su tope).
        priceBox.querySelectorAll('[data-price-range], [data-price-num]').forEach(function (el) {
          el.disabled = true;
        });
        priceBox.querySelectorAll('[data-price-input]').forEach(function (el) {
          if (!el.value) el.disabled = true;
        });
      }
      form.submit();
    }

    // #27: el filtro de precio NO está habilitado en Search & Discovery, así que
    // Shopify IGNORA filter.v.price.*. Lo aplicamos en cliente sobre las tarjetas
    // cargadas leyendo el rango de la URL (el slider ya lo pone allí al enviar).
    applyClientPriceFilter(root);

    // #29: Shopify ordena title-ascending/descending por el título BASE (inglés),
    // así que en /es el orden sale caótico. Re-ordenamos la página cargada por el
    // título VISIBLE (traducido) con localeCompare del idioma activo.
    applyLocaleTitleSort(root);

    setupInfiniteScroll(root);
  }

  // Filtro de precio en cliente (fallback a Search & Discovery sin configurar).
  // Lee filter.v.price.gte/lte de la URL (en unidades de moneda) y oculta las
  // tarjetas cuyo precio (data-card-price, en céntimos) cae fuera del rango.
  // Nota: opera sobre la página cargada; si la colección tiene varias páginas,
  // sube `Productos por página` o habilita el filtro de precio en S&D para
  // filtrado nativo con paginación correcta.
  function applyClientPriceFilter(root) {
    var grid = root.querySelector('.gudslip-plp__grid');
    if (!grid) return;
    var qs = new URLSearchParams(location.search);
    var gte = parseFloat(qs.get('filter.v.price.gte'));
    var lte = parseFloat(qs.get('filter.v.price.lte'));
    if (isNaN(gte) && isNaN(lte)) return;
    var minC = isNaN(gte) ? 0 : Math.round(gte * 100);
    var maxC = isNaN(lte) ? Infinity : Math.round(lte * 100);
    var shown = 0;
    Array.prototype.forEach.call(grid.children, function (card) {
      var priceEl = card.querySelector('[data-card-price]');
      var cents = priceEl ? parseInt(priceEl.getAttribute('data-card-price'), 10) : NaN;
      var hide = !isNaN(cents) && (cents < minC || cents > maxC);
      card.style.display = hide ? 'none' : '';
      if (!hide) shown++;
    });
    // La paginación nativa desconoce el filtro cliente → se oculta para no llevar
    // a páginas incoherentes; y si no queda nada, un aviso de vacío.
    var pag = root.querySelector('[data-plp-pagination]');
    if (pag) pag.style.display = 'none';
    if (shown === 0 && !grid.querySelector('[data-plp-empty-client]')) {
      var empty = document.createElement('p');
      empty.setAttribute('data-plp-empty-client', '');
      empty.className = 'gudslip-plp__empty';
      empty.textContent = (root.getAttribute('data-empty-label') || 'No hay productos en este rango de precio.');
      grid.parentNode.insertBefore(empty, grid.nextSibling);
    }
  }

  // Re-orden alfabético por título traducido (solo cuando el sort es title-*).
  // Nota: reordena las tarjetas YA cargadas en el grid (la página actual). Con
  // paginación clásica cada página ya viene ordenada por Shopify (título base);
  // esto corrige el orden VISIBLE al idioma. Para orden global real haría falta
  // el sort nativo, que Shopify no ofrece por título traducido.
  function applyLocaleTitleSort(root) {
    var grid = root.querySelector('.gudslip-plp__grid');
    if (!grid) return;
    var checked = root.querySelector('input[name="sort_by"]:checked');
    var sort = checked ? checked.value : new URLSearchParams(location.search).get('sort_by');
    var priceSort = sort === 'price-ascending' || sort === 'price-descending';
    if (!priceSort && sort !== 'title-ascending' && sort !== 'title-descending') return;
    var lang = document.documentElement.lang || 'es';
    var dir = sort === 'title-descending' || sort === 'price-descending' ? -1 : 1;
    var cards = Array.prototype.slice.call(grid.children);
    cards.sort(function (a, b) {
      if (priceSort) {
        var pa = a.querySelector('[data-card-price]');
        var pb = b.querySelector('[data-card-price]');
        return dir * (Number(pa && pa.getAttribute('data-card-price')) - Number(pb && pb.getAttribute('data-card-price')));
      }
      var ta = (a.querySelector('.gudslip-card__title') || {}).textContent || '';
      var tb = (b.querySelector('.gudslip-card__title') || {}).textContent || '';
      return dir * ta.trim().localeCompare(tb.trim(), lang, { sensitivity: 'base', numeric: true });
    });
    cards.forEach(function (c) { grid.appendChild(c); });
  }

  // ── Scroll infinito (progresivo, SEO-safe) ────────────────────────────────
  // La paginación real (rel=prev/next) sigue en el HTML: sin JS pagina normal y
  // los crawlers la siguen. Con JS: se oculta y se cargan las páginas siguientes
  // por fetch al acercarse al final, actualizando la URL a la página cargada.
  function setupInfiniteScroll(root) {
    // Por defecto la PLP pagina de forma clásica (1 · 2 · 3): el scroll infinito
    // solo se activa si el ajuste `infinite_scroll` de la sección lo pide.
    if (root.getAttribute('data-plp-infinite') !== 'true') return;
    if (!('IntersectionObserver' in window) || !window.fetch || !window.DOMParser) return;
    var grid = root.querySelector('.gudslip-plp__grid');
    var nav = root.querySelector('[data-plp-pagination]');
    if (!grid || !nav) return;

    var nextEl = nav.querySelector('[data-plp-next]');
    var nextUrl = nextEl ? nextEl.getAttribute('href') : null;
    var labelMore = nav.getAttribute('data-label-more') || 'Load more';
    var labelLoading = nav.getAttribute('data-label-loading') || 'Loading…';

    // Modo infinito: oculta la paginación numérica (sigue en el DOM = SEO) y
    // muestra un botón/centinela. Botón = accesible; el observer lo dispara solo.
    nav.classList.add('is-infinite');
    var wrap = document.createElement('div');
    wrap.className = 'gudslip-plp__more';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gudslip-plp__more-btn';
    btn.textContent = labelMore;
    wrap.appendChild(btn);
    nav.parentNode.insertBefore(wrap, nav);

    var loading = false;
    var done = !nextUrl;
    if (done) { wrap.hidden = true; return; }

    function load() {
      if (loading || done || !nextUrl) return;
      loading = true;
      btn.textContent = labelLoading;
      btn.classList.add('is-loading');
      var url = nextUrl;
      window.fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('.gudslip-plp__grid');
          if (newGrid) {
            var frag = document.createDocumentFragment();
            while (newGrid.firstElementChild) frag.appendChild(newGrid.firstElementChild);
            grid.appendChild(frag);
          }
          // URL apunta a la página cargada (compartible / botón atrás sensato)
          try { window.history.replaceState(window.history.state, '', url); } catch (e) {}
          var nl = doc.querySelector('[data-plp-next]');
          nextUrl = nl ? nl.getAttribute('href') : null;
          done = !nextUrl;
          loading = false;
          btn.classList.remove('is-loading');
          if (done) {
            io.disconnect();
            wrap.hidden = true;
          } else {
            btn.textContent = labelMore;
          }
        })
        .catch(function () {
          loading = false;
          btn.classList.remove('is-loading');
          btn.textContent = labelMore;
        });
    }

    btn.addEventListener('click', load);
    // Precarga cuando el centinela se acerca (600px antes de llegar al final)
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) load();
    }, { rootMargin: '600px 0px' });
    io.observe(wrap);
  }

  function boot() {
    var roots = document.querySelectorAll('[data-plp]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
